export enum MaterialType {
    Complementar = 0,
    Booklet = 2
}
